import request from '../utils/request';

//场地列表
export function getSiteList(data) {
    return request({
        url: 'home/space/list',
        method: 'post',
        data: data,
    });
}
//场地详情
export function getSiteInfo(data) {
    return request({
        url: 'home/space/info',
        method: 'post',
        data: data,
    });
}
//添加场地
export function saveSite(data) {
    return request({
        url: 'home/space/save',
        method: 'post',
        data: data,
    });
}
//删除场地
export function delSite(data) {
    return request({
        url: '/home/space/del',
        method: 'post',
        data: data,
    });
}
//场地类型
export function spacecateList(data) {
    return request({
        url: 'home/spacecate/list',
        method: 'post',
        data: data,
    });
}
//场地类型
export function setStatus(data) {
    return request({
        url: 'home/space/up_status',
        method: 'post',
        data: data,
    });
}
//场地案例

export function setSiteCase(data) {
    return request({
        url: 'home/spacecase/save',
        method: 'post',
        data: data,
    });
}
//新增类型


export function addSiteCate(data) {
    return request({
        url: 'home/spacecate/save',
        method: 'post',
        data: data,
    });
}
//场地参数更新

export function updateSiteCase(data) {
    return request({
        url: 'home/space/up_hot_sort',
        method: 'post',
        data: data,
    });
}
//删除案例

export function deleteSiteCase(data) {
    return request({
        url: 'home/spacecase/del',
        method: 'post',
        data: data,
    });
}
//案例列表

export function SiteCase(data) {
    return request({
        url: 'home/spacecase/get_list',
        method: 'post',
        data: data,
    });
}
//案例列表

export function SiteCaseInfo(data) {
    return request({
        url: 'home/spacecase/info',

        method: 'post',
        data: data,
    });
}
//管理员列表

export function manageList(data) {
    return request({
        url: 'home/spacesales/list',
        method: 'post',
        data: data,
    });
}
//新增管理员

export function addManage(data) {
    return request({
        url: 'home/spacesales/save',
        method: 'post',
        data: data,
    });
}
//管理员详情

export function manageInfo(data) {
    return request({
        url: 'home/spacesales/info',
        method: 'post',
        data: data,
    });
}
//管理员冻结

export function manageDj(data) {
    return request({
        url: 'home/spacesales/up_status',
        method: 'post',
        data: data,
    });
}
//管理员冻结

export function delManage(data) {
    return request({
        url: 'home/spacesales/del',
        method: 'post',
        data: data,
    });
}



